export default "__VITE_ASSET__DwDR3RQJ__"